module.exports = __webpack_public_path__ + "img/corner-joint-left-external.c6c795c8.svg";